import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { Card, CardSection } from "cxa-components";

const Step = ({ num, activeIndex, children }) => {
  return (
    <div
      className={`step-item  ${
        num == activeIndex ? "active-step" : num < activeIndex ? "completed-step" : ""
      }`}
    >
      {num > 0 && (
        <div className="step-connector">
          <span className="connector-line"></span>
        </div>
      )}
      <span className="step-content">
        <button className={`step-btn`}>{num + 1}</button>
        <span className="step-name">
          {num == activeIndex && <strong>{children}</strong>}
          {num !== activeIndex && children}
        </span>
      </span>
    </div>
  );
};

const EnrollmentStepper = ({ intl, index, steps }) => {
  const [isSticky, setSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Card className="enrollment-card">
      <CardSection>
        <div
          className="step-container"
          style={
            isSticky
              ? {
                  position: "fixed",
                  width: "100vw",
                  top: "-1rem ",
                  zIndex: 10,
                  backgroundColor: "#FFF",
                  left: "0",
                }
              : {}
          }
        >
          {steps &&
            steps.length > 0 &&
            steps.map(({ benefitTypeName, benefitTypeId }, idx) => {
              return (
                <Step key={benefitTypeId} num={idx} activeIndex={index || 0}>
                  {intl.formatMessage({ id: benefitTypeName, defaultMessage: benefitTypeName })}
                </Step>
              );
            })}
        </div>
        <div className="active-step-name">
          <strong>{steps[index].benefitTypeName}</strong>
        </div>
      </CardSection>
    </Card>
  );
};

EnrollmentStepper.propTypes = {
  steps: PropTypes.array.isRequired,
  index: PropTypes.number,
  intl: PropTypes.func,
};
Step.propTypes = {
  children: PropTypes.object,
  num: PropTypes.number,
  activeIndex: PropTypes.number,
};

export default injectIntl(EnrollmentStepper);



// WEBPACK FOOTER //
// ./components/employee/shop/EnrollmentStepper.js